<template>
  <div class="flex flex-wrap gap-4">
    <NKbd kbd="solid" label="Enter" />

    <NKbd kbd="outline" label="Enter" />

    <NKbd kbd="~" label="Enter" />
  </div>
</template>
